<template>
  <DragPanel title="视口" :closePanel="closePanel" :tooltipVisible="false">
    <ViewportList
      :viewportList="viewportList"
      @openViewportDetailsPanel="openViewportDetailsPanel"
    />
    <ViewportDetailsPanel
      v-if="isViewportDetailsPanelVisible"
      :viewportDetails="viewportDetails"
      :closeViewportDetailsPanel="closeViewportDetailsPanel"
    />
  </DragPanel>
</template>

<script>
import DragPanel from "@/components/CustomDragPanel.vue";
import ViewportList from "./ViewportList.vue";
import ViewportDetailsPanel from "./ViewportDetailsPanel.vue";

import { getSceneViewportListService } from "@/service/share/sceneShareInterface.js";

export default {
  data() {
    return {
      viewportList: [],

      isViewportDetailsPanelVisible: false,
      viewportDetails: {},
    };
  },
  props: {
    closeViewportPanel: Function,
  },
  components: {
    DragPanel,
    ViewportList,
    ViewportDetailsPanel,
  },
  mounted() {
    this.initViewportList();
  },
  methods: {
    initViewportList() {
      this.queryViewportList().then((viewportList) => {
        this.viewportList = viewportList;
      });
    },
    openViewportDetailsPanel(viewportInfo) {
      this.viewportDetails = viewportInfo;
      this.isViewportDetailsPanelVisible = true;
    },
    closeViewportDetailsPanel() {
      this.viewportDetails = {};
      this.isViewportDetailsPanelVisible = false;
    },
    queryViewportList() {
      return new Promise((resolve) => {
        let sceneId = this.$route.params.resourceId;
        let headers = this.getHeaders();
        getSceneViewportListService(sceneId, headers).then((response) => {
          if (response.isSuccess) {
            let viewportList = response.data;
            resolve(viewportList);
          } else {
            this.$message.error(response.errMsg);
          }
        });
      });
    },
    closePanel() {
      this.closeViewportPanel();
    },
    getHeaders() {
      let token = this.$route.query.token;
      let headers = {
        Authorization: token,
      };
      return headers;
    },
  },
};
</script>

<style lang="less" scoped>
.common-drag-panel {
  top: 214px;
  right: 20px;
  width: 360px;
  height: calc(100% - 225px);
  min-width: 300px;

  :deep(.content) {
    display: flex;
    flex-direction: column;
    height: calc(100% - 40px);
    padding: 8px 16px 16px 16px;
  }
}
</style>